import { Injectable, inject } from "@angular/core";
import { from, Observable, of } from "rxjs";
import { catchError, first } from "rxjs/operators";
import { HttpErrorResponse } from "@angular/common/http";
import LoadingService from "../services/loading.service";
import { AuthService } from "@bbj/components";

@Injectable()
export default class ErrorResolve {
  private authService = inject(AuthService);
  private loadingService = inject(LoadingService);

  resolve(): Observable<string | void> {
    this.loadingService.start();
    return from(this.authService.login()).pipe(
      first(),
      catchError((error: HttpErrorResponse) => {
        return of();
      }),
    );
  }
}
